<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Jenis Dokumen"
        class="card-wrapper"
        >
        <form>
          <div style="height: 80px" class="form-input row">
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Nama</p>
              <v-text-field
                  v-model="searchForm.nama"
                  placeholder="Nama"
                  dense
                  outlined
              />
            </div>
            <div class="col-4">
              <p class="label font-weight-bold mb-1">Alur Persetujuan</p>
              <v-select
                :items="listAlurPersetujuan"
                no-data-text="Tidak ada data"
                placeholder="Pilih Alur Persetujuan"
                clearable
                dense
                outlined
                v-model="searchForm.alur_persetujuan"
                @keydown.enter.prevent
            ></v-select>
            </div>
            <div class="col-2">
              <p class="label font-weight-bold mb-1"><br></p>
              <v-btn
                  color="primary"
                  class="mr-4"
                  @click="searchJenisDokumen()"
              >
                Cari
              </v-btn>
            </div>
          </div>
          <br>
         
        </form>
        <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            class="esign-table-search"
            prepend-inner-icon="mdi-magnify"
            label="Cari Jenis Dokumen"
            outlined
            dense
            clearable
            single-line
            hide-details
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-btn v-if="currentPeran ==='A01'"
              color="primary"
              class="mr-4"
              @click="addItem()"
          >
            Tambah
          </v-btn>
        </v-card-title>
        <!-- <div class="col-8">
          <v-text-field
          v-model="search"
          class="esign-table-search"
          prepend-inner-icon="mdi-magnify"
          label="Cari di tabel"
          outlined
          dense
          clearable
          single-line
          hide-details
        ></v-text-field>
        </div> -->
       
        <v-data-table
            :headers="headers"
            :search="search"
            :items="items"
            no-data-text="Tidak ada data"
            no-results-text="Data tidak ditemukan"
            class="elevation-1"
            :loading="isLoading"
            loading-text="Memuat data..."
            :options.sync="options"
            hide-default-footer  
        >
          <template v-slot:footer="{ props, on }">
            <esign-table-footer
            :pagination="props.pagination"
            :options="props.options"
            @update:options="on['update:options']"
            />
          </template>
        <template v-slot:item.status="{ item }">
          <esign-status-tag :tone="item.status == true ? 'success' : 'neutral'">{{ item.status == true ? "Aktif" : "Tidak Aktif" }}</esign-status-tag>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="orange" dark @click="editItem(item)"><v-icon small class="mr-1"> mdi-pencil </v-icon>Ubah</v-btn>
          <v-btn class="mx-1 mt-1 mb-1" v-if="currentPeran ==='A01'" x-small color="red" dark @click="deleteItem(item)"><v-icon small class="mr-1"> mdi-delete </v-icon>Hapus</v-btn>
        </template>
      </v-data-table>

        </v-card>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card class="card-modal">
            <v-card-title>
              <span class="headline">Hapus Jenis Dokumen</span>
            </v-card-title>
  
            <v-card-text>
              Apakah anda yakin hapus jenis dokumen {{namaDelete}}?
            </v-card-text>
  
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn @click="close">Batal</v-btn>
              <v-btn color="primary" dark @click="confirmDelete">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";
export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["search", "searchForm", "options"],
  data: () => ({
    search: "",
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    currentPeran: "",
    isLoading: true,
    menu: false,
    dialog: false,
    items: [],
    headers: [
      { text: "Nama", value: "nama" },
      { text: "Alur Persetujuan", value: "alur_persetujuan"},
      { text: "Status", value: "status"},
      { text: "Aksi", value: "action", sortable: false, width:'200px'},
    ],
    searchForm: {
      nama: "",
      alur_persetujuan: "",
    },
    options: {},
    totalData: 0,
    listAlurPersetujuan: [],
    namaDelete: "",
    idDelete: 0
  }),

  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true
    }
  },

  created() {
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    this.getDropdownAlurPersetujuan()
    // this.debounceSearch = _.debounce(this.searchTableSearch, 500)
  },

  methods: {
    getData() {
      this.isLoading = true;
      console.log("search form", this.searchForm);
      // this.searchForm.nama = this.options
      // this.searchForm.FlagAktif = this.searchForm.FlagAktif == "T" ? "T" : "F";
      apiServer
          .get("/jenis_dokumen/all", {
            params: {
              nama: this.searchForm.nama,
              alur_persetujuan: this.searchForm.alur_persetujuan
            }
          })
          .then(response => {
            console.log("get all jenis dokumen: ", response.data.data)
            this.items = response.data.data;
            this.totalData = response.data.total
            this.isLoading = false;
            this.currentPeran = localStorage.getItem("currentPeran")
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
          });
    },
    searchTableSearch() {
      this.searchForm.search = this.search
      this.getData()
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    editItem(item){
      this.$router.push('/ubah-jenis-dokumen/' + item.id);
    },
    searchJenisDokumen(){
      // console.log("search")
      this.search = ""
      this.options.page = 1
      this.getData()
    },
    addItem(){
      this.$router.push('/tambah-jenis-dokumen');
    },
    deleteItem(val) {
      console.log("delete " +val.id)
      // if (val.status == true) {
      //   this.showSnackbar("error", "Jenis dokumen masih berstatus aktif.")
      // } else {
        this.dialog = true
        this.namaDelete = val.nama
        this.idDelete = val.id
      // }
    },
    close() {
      this.namaDelete = ""
      this.idDelete = 0
      this.dialog = false;
    },
    confirmDelete() {
      apiServer
          .delete("/jenis_dokumen/delete/" + this.idDelete)
          .then(response => {
            this.showSnackbar("orange", "Jenis dokumen berhasil dihapus");
            this.close()
            this.getData()
          })
          .catch(error => {
            console.log("There was an error:", error.response.data.message);
            var error_message = "Error, please contact your administrator!"
            if (error.response.data.message.includes("violates")) {
              error_message = "Jenis dokumen tidak dapat dihapus karena menjadi referensi untuk fitur lain."
            } else if (error.response.data.message.includes("berstatus Aktif")) {
              error_message = error.response.data.message
            }
            this.close()
            this.showSnackbar(
                "error",
                error_message
            );
          });
    },
    getDropdownAlurPersetujuan() {
      console.log("dropdown", this.searchForm);
      apiServer
          .get("/jenis_dokumen/dropdown_alur_persetujuan")
          .then(response => {
            console.log("get dropdown_alur_persetujuan: ", response.data.data)
            this.listAlurPersetujuan = response.data.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
    },
  }
};
</script>